export default __webpack_public_path__ + "locales/az/Common.json?hash=fb71a8fd1a82085fc20a512ae9668cc6";